//@ts-check

import React from "react";
import { Chip } from "@material-ui/core"

export default function PassFailChips({pass_expections,textOnly=false}) {
  if(textOnly) {
    if(pass_expections) return <span> - Pass</span>
    if(pass_expections===false) return <span> - Failed</span>
  }
  return (
  <>
      {pass_expections &&
        //@ts-ignore
        <Chip
        type="error"
        label="PASS"
        style={{ background: "#168736", color: "#F6F6FA" }}
        />
      }
      {pass_expections === false &&
        //@ts-ignore
        <Chip
        type="error"
        label="FAIL"
        style={{ background: "#B9251C", color: "#F6F6FA" }}
        />
      }
  </>)
}